import { ParseKeys } from "i18next";

import { RelationshipType } from "../../api/ClientFileApi";

const RELATIONSHIP_LABEL_KEYS: Record<RelationshipType, ParseKeys> = {
  Acquaintance: "clients.client.debtSettlement.assetInventory.dependants.relationshipOptions.acquaintance",
  Parent: "clients.client.debtSettlement.assetInventory.dependants.relationshipOptions.parent",
  ExSpouse: "clients.client.debtSettlement.assetInventory.dependants.relationshipOptions.exSpouse",
  ExPartner: "clients.client.debtSettlement.assetInventory.dependants.relationshipOptions.exPartner",
  Spouse: "clients.client.debtSettlement.assetInventory.dependants.relationshipOptions.spouse",
  Child: "clients.client.debtSettlement.assetInventory.dependants.relationshipOptions.child",
  Partner: "clients.client.debtSettlement.assetInventory.dependants.relationshipOptions.partner",
  Other: "clients.client.debtSettlement.assetInventory.dependants.relationshipOptions.other",
  Unknown: "clients.client.debtSettlement.assetInventory.dependants.relationshipOptions.unknown",
  Relative: "clients.client.debtSettlement.assetInventory.dependants.relationshipOptions.relative",
};

export function relationshipLabelKey(relationship: RelationshipType): ParseKeys {
  return RELATIONSHIP_LABEL_KEYS[relationship];
}
